import React from 'react';
import { UncontrolledCollapse, Button, CardBody, Card, Row, Col } from 'reactstrap';

const Advanced = () => (
  <div>
    <h2>Advanced HD TV</h2>
    <p>Over 130 channels in high quality, ultra sharp, High Definition! Also includes 50 high quality music channels. Priced starting at $125</p>
    <Button outline color="success" id="advtoggle" style={{ marginBottom: '1rem' }}>
      Show/Hide Channel Listing
    </Button>
    <UncontrolledCollapse toggler="#advtoggle">
      <Card>
        <CardBody>
        <Row>
            <Col sm="6">
              3 - WSIL ABC<br />
              4 - WSIL Weather Bug<br />
              6 - WPSD NBC<br />
              7 - WPSD This TV<br />
              8 - WPSD Antenna<br />
              9 - KAIT ABC<br />
              10 - HSN<br />
              12 - KFVS CBS<br />
              13 - KFVS CW<br />
              14 - KFVS Grit<br />
              15 - QVC<br />
              23 - KBSI FOX<br />
              24 - KBSI Comet<br />
              34 - CSPAN 1<br />
              35 - CSPAN 2<br />
              36 - CSPAN 3<br />
              37 - NASA<br />
              40 - EvineLive<br />
              49 - WDKA MyNet<br />
              50 - WDKA Charge<br />
              51 - WDKA TBD<br />
              52 - WDKA Stadium<br />
              70 - EWTN<br />
              71 - TBN<br />
              72 - TCT<br />
              73 - Daystar<br />
              74 - SMILE<br />
              75 - The Hillsong Channel<br />
              76 - JUCE tv<br />
              77 - God TV<br />
              78 - 3ABN<br />
              90 - Lake TV<br />
              481 - Event TV HD (Pay-per-view)<br />
              981 - Event TV SD (Pay-per-view)<br />
              <br />
              100 - A&E<br />
              101 - AMC<br />
              102 - Bravo<br />
              103 - Comedy Central<br />
              104 - Hallmark Channel<br />
              105 - E!<br />
              106 - DIY Network<br />
              107 - HGTV<br />
              108 - FXX<br />
              109 - FX<br />
              110 - Paramount Network<br />
              111 - SyFy<br />
              113 - TBS<br />
              115 - TNT<br />
              116 - USA<br />
              117 - FOOD<br />
              118 - Cooking Channel<br />
              119 - Discovery Life<br />
              120 - Logo<br />
              121 - truTV<br />
              122 - BET<br />
              123 - GSN<br />
              124 - Grit<br />
              125 - INSP<br />
              150 - Freeform<br />
              151 - Cartoon Network<br />
              152 - Disney Channel<br />
              153 - Disney XD<br />
              154 - Nickelodeon<br />
              155 - TV Land<br />
              156 - Discovery Channel<br />
              157 - Nick Too<br />
              158 - Nick Jr.<br />
              159 - Nicktoons<br />
              161 - TeenNick<br />
              162 - Boomerang<br />
              163 - Disney Jr.<br />
              180 - CMT<br />
              181 - CMT Music<br />
              182 - Great American Country<br />
              183 - MTV<br />
              184 - VH1<br />
              185 - MTV2<br />
              186 - Nick Music<br />
              187 - BET Jams<br />
              188 - MTV Classic<br />
              189 - BET Soul<br />
              199 - WE tv<br />
              200 - Lifetime Movies<br />
              201 - Lifetime Movie Network<br />
              202 - Oxygen<br />
              203 - OWN<br />
              204 - Hallmark Movies and Mysteries Channel<br />
              206 - FX Movie Channel<br />
              207 - IFC<br />
              208 - Sundance<br />
              210 - AXS TV<br />
              </Col>
              <Col sm="6">  
              250 - CNBC<br />
              251 - CNN<br />
              252 - Fox News Channel<br />
              254 - Headline News<br />
              255 - MSNBC<br />
              256 - Weather Channel<br />
              260 - Military History Channel<br />
              261 - fyi<br />
              262 - History<br />
              263 - Viceland<br />
              264 - Investigation Discovery<br />
              265 - TLC<br />
              266 - Crime + Investigation<br />
              267 - Animal Planet<br />
              268 - Discovery Channel<br />
              269 - National Geographic<br />
              270 - Destination America<br />
              271 - National Geographic Wild<br />
              272 - Science<br />
              273 - Travel Channel<br />
              274 - AHC<br />
              275 - RFD TV<br />
              276 - The Cowboy Channel<br />
              300 - ESPN<br />
              301 - ESPN2<br />
              302 - Fox Sports Midwest<br />
              303 - Fox Sports Midwest Plus<br />
              304 - Fox Sports Midwest Plus 2<br />
              305 - Fox Sports 1<br />
              306 - Fox Sports 2<br />
              307 - ESPNEWS<br />
              308 - ESPNU<br />
              309 - ESPN Classic<br />
              310 - Golf Channel<br />
              311 - NFL Network<br />
              313 - SEC Network<br />
              314 - SEC Network Alternate<br />
              315 - SEC Network Alternate 2<br />
              340 - Velocity<br />
              <br />
              <h4>MUSIC</h4>
              350 - Adult Alternative<br />
              351 - Classic Rock<br />
              352 - Rock Alternative<br />
              353 - The Blues<br />
              354 - Country Classics<br />
              355 - Alt-Country Americana<br />
              356 - Hot Country<br />
              357 - No Fences<br />
              358 - Bluegrass<br />
              359 - Folk Roots<br />
              360 - Jazz Masters<br />
              361 - Easy Listening<br />
              362 - Flashback 70's<br />
              363 - Everything 80's<br />
              364 - Swinging Standards<br />
              365 - Hit List<br />
              366 - Jukebox Oldies<br />
              367 - Pop Adult<br />
              368 - The Light<br />
              369 - Urban Beats<br />
              370 - Gospel<br />
              371 - Holiday Hits<br />
              372 - Today's Latin Pop<br />
              373 - Rock en Espanol<br />
              374 - Pop Classics<br />
              375 - Rock<br />
              376 - Heavy Metal<br />
              377 - All Rock Classics<br />
              378 - Jazz Now<br />
              379 - Smooth JazzDirect<br />
              380 - Hip Hop<br />
              381 - Dance Clubbin'<br />
              382 - Nothin' but 90's<br />
              383 - Groove (Disco and Funk)<br />
              384 - Maximum Party<br />
              385 - Soul Storm<br />
              386 - Classic R'n'B Soul<br />
              387 - Jammin<br />
              388 - Latino Tropical<br />
              389 - Latino Urbana<br />
              390 - Retro Latino<br />
              391 - Romance Latino<br />
              392 - Broadway<br />
              393 - Chamber Music<br />
              394 - Classical Masters<br />
              395 - Eclectic Electronics<br />
              396 - Y2K<br />
              397 - The Chill Lounge<br />
              398 - The Spa<br />
              399 - Kid's Stuff<br />
            </Col>
          </Row>
        </CardBody>
      </Card>
    </UncontrolledCollapse>
  </div>
);

export default Advanced;


// WEBPACK FOOTER //
// ./src/components/sections/services/tv/advanced.js